import { createStyles, WithStyles } from '@material-ui/core';
import { Theme, withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    const spacing = theme.spacing(3);
    return createStyles({
        pane: {
            display: 'flex',
            position: 'relative',
            height: '100%',
            width: '100%',
            zIndex: 13,
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: spacing,
        },
        wrapper: {
            display: 'flex',
            position: 'relative',
            flexGrow: 1,
            flexDirection: 'column',
        },
        switch: {
            display: 'flex',
            alignItems: 'center',
            marginRight: theme.spacing(2),
        },
    });
};

export type TThemableProps = WithStyles<typeof styles>;

export const Themable = withStyles(styles, { withTheme: true });
